module.exports = __webpack_public_path__ + "img/orb-1.b4dc4b09.svg";